import React from 'react';

const CoreComponent6 = ({ contents }) => {
  return (
    <div className="row overflow-hidden">
      {contents.map((val, i) => (
        <div key={i} className="col-12 col-lg-6 mb-4 d-flex justify-content-center">
          <div className={`row w-100 ${val.reverse ? 'flex-column flex-lg-row-reverse' : 'flex-column flex-lg-row'}`}>
            {/* Text Section */}
            <div className="col-12 col-lg-6 px-3 py-3 d-flex flex-column justify-content-center bg-dark">
              <h2 className="h2-heading text-start font-gordita pb-1" style={{ color: '#d3d3d3' }}>{val.num}</h2>
              <h3 className="h3-heading fs-5 text-white lh-1 mt-1 text-start">{val.title}</h3>
              <p className="h1-para  my-2 fs-6 lh-base text-white text-start pt-2" style={{ opacity: 0.6 }}>{val.desc}</p>
            </div>

            {/* Image Section */}
            <div className="col-12 col-lg-6 px-0">
              <img src={val.icon} className="img-fluid w-100 h-100 object-fit-cover" alt="" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CoreComponent6;
